import { openMailWithGmailFallback } from '@/utils/mailto'

import * as S from './field-row.styled'
import type { FieldExternalLinkProps } from './field-row.types'
import { getExternalHref } from './field-row.utils'

export const FieldExternalLink = ({ kind, value }: FieldExternalLinkProps) => (
  <S.ExternalLink
    href={getExternalHref(kind, value)}
    rel="noopener noreferrer"
    target={kind === 'url' ? '_blank' : undefined}
    onClick={kind === 'email' ? () => openMailWithGmailFallback(value) : undefined}
  >
    {value}
  </S.ExternalLink>
)
